<script>
import Integrations from '~/api/integrations';
import VueButton from '~/components/button/components/button';
import { Message } from 'element-ui';

const MAX_TIMEOUT = 200000;

export default {
    name: 'oauth-connect-link',

    components: {
        VueButton
    },

    props: {
        integrationName: {
            type: String,
            default: null
        },

        cssClass: {
            type: String,
            default: 'btn btn-white'
        },

        connectUrl: {
            type: String,
            default: ''
        },

        type: {
            type: String,
            default: 'primary'
        }
    },

    computed: {
        waitingForOAuth: {
            get: function () {
                return this.connectionIsLoading
            },
            set: function (value) {
                this.connectionIsLoading = value;
            }
        }
    },

    data() {
        return {
            authWindowRef: null,
            connectionIsLoading: false,
            integration: {
                connect_url: null,
                disconnect_url: null,
                is_integrated: null
            }
        }
    },

    created() {
        this.getIntegrations();
    },

    methods: {
        openAuthWindow() {
            let connectUrl = this.getConnectUrl();

            if (this.authWindowRef) {
                this.authWindowRef.close();
            }

            var authWindow = this.authWindowRef = window.open(
                connectUrl,
                'AuthWindow',
                'left=20,top=20,width=580,height=500,toolbar=1,resizable=0'
            );

            this.waitingForOAuth = true;

            var authWindowInterval = window.setInterval(
                function() {
                    if (authWindow.closed !== false) {
                        window.clearInterval(authWindowInterval);
                        this.getValidationStatus();
                    }
                }.bind(this),
                200
            );
        },

        getConnectUrl() {
            return this.connectUrl ? this.connectUrl : `${window.location.origin}/integration/reset?name=${this.integrationName}`;
        },

        closeAuthWindow() {
            this.authWindowRef.close();
        },

        getIntegrations() {
            Integrations.getIntegration({
                name: this.integrationName
            }).then((data) => {
                Object.assign(this.integration, data.integration);
            });
        },

        getValidationStatus() {
            $.ajax({
                url: '/integration/validate',
                data: {
                    name: this.integrationName
                },
                method: 'GET',
                global: false
            })
            .done((data) => {
                this.waitingForOAuth = false;

                if (data.is_integrated) {
                    this.$emit('connect', this.integrationName, data);
                } else {
                    buildFlashMessage('Could not validate the integration. Please wait a moment and try again.', 'warning');
                }
            })
            .fail((xhr) => {
                var errorMessage = 'An error occured while connecting';
                if (typeof xhr.responseJSON !== 'undefined' && typeof xhr.responseJSON.error === 'string') {
                    errorMessage += ': ' + xhr.responseJSON.error
                }

                Message({
                    type: 'error',
                    message: errorMessage,
                    showClose: true
                });
            });
        }
    }
}
</script>

<template>
    <vue-button
        href="javascript:;"
        loading-text="Loading"
        :type="type"
        @click="openAuthWindow"
        :class="[cssClass]"
        :loading="waitingForOAuth"
    >
        <slot></slot>
    </vue-button>
</template>
